import React, { useContext } from 'react';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';

function CouponName() {
    const { formInputs, setFormInputs, formErrors } = useContext(AddCouponFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        setFormInputs({ ...formInputs, [name]: formattedValue });
    };

    return (
        <div className="border border-[#EAEAEA] rounded-xl p-5">
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <label className='font-medium text-[18px] leading-6 text-[#121212] w-fit cursor-pointer select-none' htmlFor="name">Coupon name</label>
                            
                    <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.name}</p>
                </div>

                <input 
                    className='outline-none px-3 py-4 rounded-[9px] bg-[#F5F5F5] border border-[#EAEAEA] placeholder:font-normal placeholder:text-[#666666] text-base font-medium text-[#121212]'
                    id='name' 
                    name='name' 
                    type="text" 
                    placeholder='Enter coupon name' 
                    value={formInputs.name} 
                    onChange={handleChange} 
                />
            </div>
        </div>
    );
}

export default CouponName;
